'use client';
import { createStyles, xref, rem } from '@s7/styles';

var useStyles = createStyles(function(theme, param) {
    var transitionDuration = param.transitionDuration, chevronPosition = param.chevronPosition, chevronSize = param.chevronSize;
    var _obj;
    return {
        chevron: {
            boxSizing: "border-box",
            ref: xref("chevron"),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: rem(chevronSize),
            height: rem(chevronSize),
            minWidth: rem(chevronSize),
            transition: "transform " + transitionDuration + "ms ease",
            "&[data-rotate]": {
                transform: "rotate(180deg)"
            },
            borderRadius: theme.fn.borderRadius()
        },
        label: {
            flex: 1,
            margin: 0,
            paddingTop: rem(20),
            paddingBottom: rem(20)
        },
        control: (_obj = {
            boxSizing: "border-box",
            cursor: "pointer"
        }, _obj["&:focus-visible ." + xref("chevron")] = theme.fn.border({
            color: theme.palette.primary.mid,
            width: rem(3)
        }), _obj.display = "flex", _obj.alignItems = "center", _obj.flexDirection = chevronPosition === "right" ? "row-reverse" : "row", _obj.width = "100%", _obj.textAlign = "left", _obj.color = theme.palette.text.quaternary, _obj["&:disabled"] = {
            opacity: 0.4,
            cursor: "not-allowed",
            "&:hover": {
                backgroundColor: "transparent"
            }
        }, _obj)
    };
});

export { useStyles as default };
